export default "__VITE_ASSET__De2gvsoY__"